import { SidebarCol } from "../../chatMain/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { MainHeader } from "../../chatMain/MainHeader/MainHeader.jsx";
import { Calendar } from "./Calendar"
import { EventCard } from "./EventCard"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faCalendar, faClock } from '@fortawesome/free-solid-svg-icons';

import "./LiveMainView.css";

export const LiveMainView = () => {
  const navigate = useNavigate();
  return (
    <div className="LiveMainView">
      <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'/>
      <div className="sidebarLive">
        <SidebarCol />
      </div>
      <div className="LiveMainViewEvents">
        <MainHeader page="Live Events" titleText="Live Guided Mindfulness Sessions" subtitleText="Join real-time sessions to reduce stress and connect with others." back={false}/>
        <div className="Location">
          <span className="EventPath">Home /{' '}</span>
          <span className="EventCurrent">Live Session</span>
        </div>
        
        <div className="EventBox">
          <EventCard  ></EventCard>
        </div>
      </div>
    </div>
  );
};//<Calendar></Calendar>
//<button onClick={()=>{navigate("/live/listview")}}>List View</button>
